'use client'

import {
  AspectRatio,
  Box,
  Flex,
  HStack,
  SimpleGrid,
  Text,
  VStack
} from '@chakra-ui/react'
import React from 'react'
import { Link as ScrollLink } from 'react-scroll'

import Image from 'next/image'
import { LocationIcon } from '@icons/location-icon'
import TriangleCenterLineImage from '@images/brands/cheongdam/triangle-center-line.png'
import Link from 'next/link'

interface Outlets {
  location: string
  stores: string[]
}

const Outlets: Outlets[] = [
  {
    location: 'Guardian - Central',
    stores: [
      'Blk 704 Ang Mo Kio Ave 8 #01-2559C',
      'Raffles City #B1-01',
      'Ang Mo Kio Hub #B2-01/02',
      'Raffles Place MRT #B1-37-40/43-45',
      'City Square Mall #B1-18/19',
      'Suntec City #02-705/707',
      'Clarke Quay Central #01-55/56/57',
      'Scotts Square #B1-21/22',
      'Compass One #B1-11',
      'Seletar Mall #B1-10/11',
      'Greenwich Village, 1 Seletar Road, #01-02/16',
      '100 Tras Street, #02-09',
      'Holland Shopping Centre #01-10/11',
      'The Woodleigh Mall #B1-36',
      'Ion Orchard #B4-02',
      'Blk 190 Toa Payoh Lorong 6 #01-578',
      'Paragon #B1-20/24',
      'United Square #B1-28',
      'Plaza Singapura #B2-15'
    ]
  },
  {
    location: 'Guardian - North East',
    stores: [
      'Blk 744 Bedok Reservoir Road #01-3063',
      'Century Square #B1-01',
      '66 Serangoon Garden Way',
      '20 Tampines Central 1, # 01-01'
    ]
  },
  {
    location: 'Guardian - North West',
    stores: [
      'Bukit Panjang Plaza #01-01/02/03',
      'Sun Plaza #B1-11',
      'Causeway Point #B1-28/29/30',
      'Blk 888 Woodland Dr 50 #01-731/731A',
      'NorthPoint (NorthWing) #B1-02/03'
    ]
  },
  {
    location: 'Guardian - South East',
    stores: [
      '65 Airport Blvd, B2-24 North T3',
      'Kallang Wave Mall #01-51',
      'Blk 113 Aljunied Ave 2 #01-27',
      'One KM #B1-19/20',
      'Bedok Mall #B2-45/46/47',
      'Parkway Parade #B1-147/149',
      'Eastpoint Mall #02-01/02/35',
      'Paya Lebar Quarter #B2-01/35',
      'Kallang Leisure Park #01-23',
      'Serangoon Nex #B1-62/63'
    ]
  },
  {
    location: 'Guardian - South West',
    stores: [
      'Harbourfront Centre #02-111/112',
      'Lot 1 #B1-26/27',
      'JEM #B1-16/17',
      'Star Vista #B1-16',
      'Jurong Point B1-27/28',
      'Westgate #B1-20',
      'Blk 503 Jurong West Ave 1 #01-845'
    ]
  }
]

const OutletsLocation = ({ outlet }: { outlet: Outlets }) => {
  return (
    <Box data-aos="fade-up" mb={8} mt={3}>
      <Text textStyle={'outletTitle'} w={'100%'}>
        {outlet.location}
      </Text>
      <SimpleGrid columns={{ base: 1, sm: 2 }} gap={6} w={'100%'} mt={5}>
        {outlet.stores.map((store) => {
          return (
            <HStack key={store}>
              <Box>
                <LocationIcon width={20} height={20} />
              </Box>
              <Text textStyle={'outletText'}>{store}</Text>
            </HStack>
          )
        })}
      </SimpleGrid>
    </Box>
  )
}

const ExclusiveOffer = () => {
  return (
    <Box maxW={700} mx="auto" mt={8} mb={20}>
      <VStack data-aos="fade-up" alignItems={'center'} gap={12}>
        <Text
          textAlign={'center'}
          textStyle="gripProblemTitle"
          mt={{
            base: 2,
            sm: 4,
            lg: 12
          }}
        >
          Exclusive Offer
        </Text>
        <AspectRatio
          width={{
            base: 250,
            sm: 320,
            lg: 400
          }}
          ratio={822 / 768}
          position="relative"
          zIndex={10}
          ml={{
            base: '-40px',
            sm: '-50px',
            md: '-55px'
          }}
        >
          <Image
            alt="sale health"
            src={
              'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/Health%2B%20Oralcare%20Mouthwash%20Microsite%20%281%29-1719202885450.png'
            }
            fill
          />
        </AspectRatio>
        <Text textAlign={'center'} textStyle="gripProblemTitle">
          Participating outlets
        </Text>
      </VStack>
      <VStack data-aos="fade-up" alignItems={'center'} gap={8} mt={5}>
        <Image alt="" src={TriangleCenterLineImage} width={624} height={200} />
      </VStack>
      <Flex
        data-aos="fade-up"
        direction={{ base: 'column', sm: 'row' }}
        justify="space-between" //
        align={{ base: 'center', sm: 'center' }}
        gap={6}
        w="50%"
        mt={5}
      >
        <Box
          flex={1}
          w={{
            base: '60%',
            sm: 'auto'
          }}
          cursor="pointer"
        >
          <ScrollLink
            to="guardian"
            smooth={true}
            duration={500}
            offset={-150} // Adjusted for header height
          >
            <AspectRatio ratio={1366 / 768} position="relative">
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/guardian-1713812201249.png'
                }
                alt="guardian"
                fill
              />
            </AspectRatio>
          </ScrollLink>
        </Box>
        <Box
          cursor="pointer"
          w={{
            base: '60%',
            sm: '90px',
            md: '100px'
          }}
        >
          <AspectRatio
            w={{
              base: '100%',
              sm: '90px',
              md: '100px'
            }}
            ratio={1 / 1}
          >
            <Link
              href="https://wondershop.sg/health-oralcare-mouthwash-500ml.html?utm_source=logo&utm_medi[…]rosite&utm_campaign=oralcaremicrosite&utm_id=oralcaremicrosite"
              target="_blank"
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/wonder-1711598628576.png"
                fill
                alt="wonder"
              />
            </Link>
          </AspectRatio>
        </Box>
      </Flex>
      <VStack
        data-aos="fade-up"
        mt={20}
        w={'100%'}
        alignItems={'start'}
        id="guardian"
      >
        <Text textAlign={'left'} textStyle={'oralcareParticipateTitle'}>
          Guardian
        </Text>
      </VStack>
      {Outlets.map((outlet, i) => {
        return <OutletsLocation key={i} outlet={outlet} />
      })}
    </Box>
  )
}

export default ExclusiveOffer
